import React, { useState, useRef } from "react"
import Slider from "react-slick"
import classNames from "classnames"
import Label from "components/Label"
import Button from "components/Button"
import { useLocale } from "context/locale"
import WearFairLogotype from "icons/wear_fair.svg"
import UdoIcon from "icons/udo.svg"
import StyledCircle from "./styles"
let timer

const Circle = () => {
  const { t } = useLocale()
  const [current_slide, setCurrentSlide] = useState(1)
  const [disable_buttons, setButtonsDisabled] = useState(false)
  const [counter, setCount] = useState(1)
  const circle_slider = useRef(null)
  const settings = {
    dots: false,
    infinite: true,
    swipe: false,
    arrows: false,
    autoplay: false,
    speed: 1000,
    fade: true,
    ref: circle_slider,
    initialSlide: current_slide,
    beforeChange: () => {
      setButtonsDisabled(true)
    },
    afterChange: () => {
      setButtonsDisabled(false)
    },
    responsive: [
      {
        breakpoint: 600,
        settings: {
          fade: false,
          speed: 400,
          swipe: true,
          onSwipe: direction => {
            clearTimeout(timer)
            switch (direction) {
              case "right":
                timer = setTimeout(() => {
                  setCurrentSlide(current_slide === 0 ? 3 : current_slide - 1)
                }, 400)
                break
              case "left":
                timer = setTimeout(() => {
                  setCurrentSlide(current_slide === 3 ? 0 : current_slide + 1)
                }, 400)

                break
              default:
                break
            }
          },
        },
      },
    ],
  }
  return (
    <StyledCircle>
      <div className="circle-container">
        <header className="circle-header">
          {/* <Label text="#create_fair" /> */}
          <h2 className="title h1">{t("Towards circular fashion")}</h2>
          <p className="desc">
            {t(
              "From 2022, we are implementing a program that aims at closing the loop and transitioning towards circular fashion. It’s about both designing clothes in a more sustainable way and giving the ones that already exist a second life."
            )}
          </p>
        </header>
      </div>
      <div className="circle-animation__container">
        <div className="circle-animation__progress">
          <div
            className="rotator"
            style={{ transform: `rotate(${counter * 90}deg)` }}
          />
          <div className="step bg top" />
          <div className="step bg right" />
          <div className="step bg bottom" />
          <div className="step bg left" />
          <button
            type="button"
            className={classNames("step top", { active: current_slide === 0 })}
            onClick={() => {
              switch (current_slide) {
                case 1:
                  setCount(counter - 1)
                  break
                case 2:
                  setCount(counter - 2)
                  break
                case 3:
                  setCount(counter - 3)
                  break
                default:
                  setCount(counter)
              }
              circle_slider.current.slickGoTo(0)
              setCurrentSlide(0)
            }}
          >
            <span className="bolder">1</span>
          </button>
          <button
            type="button"
            className={classNames("step right", {
              active: current_slide === 1,
            })}
            onClick={() => {
              switch (current_slide) {
                case 0:
                  setCount(counter + 1)
                  break
                case 2:
                  setCount(counter - 1)
                  break
                case 3:
                  setCount(counter - 2)
                  break
                default:
                  setCount(counter)
              }
              circle_slider.current.slickGoTo(1)
              setCurrentSlide(1)
            }}
          >
            <span className="bolder">2</span>
          </button>
          <button
            type="button"
            className={classNames("step bottom", {
              active: current_slide === 2,
            })}
            onClick={() => {
              switch (current_slide) {
                case 0:
                  setCount(counter + 2)
                  break
                case 1:
                  setCount(counter + 1)
                  break
                case 3:
                  setCount(counter - 1)
                  break
                default:
                  setCount(counter)
              }
              circle_slider.current.slickGoTo(2)
              setCurrentSlide(2)
            }}
          >
            <span className="bolder">3</span>
          </button>
          <button
            type="button"
            className={classNames("step left", { active: current_slide === 3 })}
            onClick={() => {
              switch (current_slide) {
                case 0:
                  setCount(counter + 3)
                  break
                case 1:
                  setCount(counter + 2)
                  break
                case 2:
                  setCount(counter + 1)
                  break
                default:
                  setCount(counter)
              }
              circle_slider.current.slickGoTo(3)
              setCurrentSlide(3)
            }}
          >
            <span className="bolder">4</span>
          </button>
        </div>
        <div className="circle-animation__holder">
          <button
            disabled={disable_buttons}
            onClick={() => {
              setCurrentSlide(current_slide === 0 ? 3 : current_slide - 1)
              circle_slider.current.slickPrev()
              setCount(counter - 1)
            }}
            type="button"
            aria-label="arrow-prev"
            className="circle-arrow prev"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10.294"
              height="17.759"
              viewBox="0 0 10.294 17.759"
            >
              <path
                d="M8.88,16.7.707,8.526,8.88.354"
                transform="translate(0.707 0.353)"
                fill="none"
                stroke="#000"
                strokeWidth="2"
              />
            </svg>
          </button>
          <button
            disabled={disable_buttons}
            onClick={() => {
              setCurrentSlide(current_slide === 3 ? 0 : current_slide + 1)
              circle_slider.current.slickNext()
              setCount(counter + 1)
            }}
            type="button"
            aria-label="arrow next"
            className="circle-arrow next"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10.294"
              height="17.759"
              viewBox="0 0 10.294 17.759"
            >
              <path
                d="M.707,16.7,8.88,8.526.707.354"
                transform="translate(0 0.353)"
                fill="none"
                stroke="#000"
                strokeWidth="2"
              />
            </svg>
          </button>
          <div className="circle-animation__logotype">
            {/* <WearFairLogotype /> */}
          </div>
          <div className="circle-animation__slider">
            <Slider {...settings}>
              <div className="slider-box first">
                <p className="step-name">{t("step")} 1</p>
                <div className="step-image">
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="87.999"
                    height="69.972"
                    viewBox="0 0 87.999 69.972"
                  >
                    <path
                      d="M797.023-163.2,781.487-148.87a1.46,1.46,0,0,1-2.07-.093l-2.506-2.754-.307,31.856a1.463,1.463,0,0,1-1.462,1.447H749.314a3.734,3.734,0,0,1-3.734-3.734v-.018a3.734,3.734,0,0,1,3.734-3.734H767.73a1.459,1.459,0,0,0,1.459-1.447l.273-28.256a5.988,5.988,0,0,1,10.417-3.971,1.455,1.455,0,0,0,1.081.477,1.458,1.458,0,0,0,.993-.387l4.267-3.937a1.461,1.461,0,0,0,.044-2.107l-14.528-14.528a1.456,1.456,0,0,0-1.018-.428l-34.086-.384a1.473,1.473,0,0,0-1.052.431l-14.863,14.9a1.463,1.463,0,0,0,.041,2.107l4.435,4.09a1.461,1.461,0,0,0,2.029-.046,6.051,6.051,0,0,1,4.342-1.841,6.164,6.164,0,0,1,6.214,6.171l.044,21.4v11.5a3.734,3.734,0,0,1-3.734,3.734,3.734,3.734,0,0,1-3.734-3.734v-3.45l-.054-26.255-2.841,2.873a1.467,1.467,0,0,1-2.032.046L709.965-163.2a1.461,1.461,0,0,1-.041-2.107l22.586-22.648a1.462,1.462,0,0,1,1.052-.431l40.293.454a1.457,1.457,0,0,1,1.016.428l22.2,22.194a1.459,1.459,0,0,1-.044,2.107"
                      transform="translate(-709.496 188.387)"
                    />
                  </svg> */}
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 309 305"
                    style={{ maxHeight: "80px" }}
                  >
                    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
                      <g transform="matrix(1,0,0,1,58.834,2.897)">
                        <path
                          d="M0,67.228L-43.641,67.228L-43.641,15.894L-46.538,15.894L-46.538,26.97L-54.851,21.882L-46.777,8.698C-44.988,5.778 -42.215,3.573 -38.968,2.489L-33.782,0.758C-31.649,5.388 -27.008,8.411 -21.821,8.411C-16.636,8.411 -11.997,5.388 -9.863,0.757L-4.674,2.489C-1.426,3.574 1.348,5.779 3.136,8.699L11.21,21.882L2.897,26.97L2.897,15.894L0,15.894L0,67.228ZM-12.718,0C-14.468,3.354 -17.95,5.514 -21.821,5.514C-25.694,5.514 -29.177,3.354 -30.928,0L-12.718,0ZM5.606,7.186C3.463,3.685 0.137,1.042 -3.757,-0.258L-11.611,-2.879L-11.611,-2.897L-32.03,-2.897L-32.03,-2.881L-39.885,-0.259C-43.778,1.041 -47.103,3.685 -49.247,7.185L-58.834,22.839L-46.538,30.366L-46.538,70.125L2.897,70.125L2.897,30.366L15.193,22.839L5.606,7.186Z"
                          // style="fill-rule:nonzero;"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="step-title">
                  <p>
                    {t(
                      "You buy clothes from 4F, you enjoy them and wear them for as long as possible."
                    )}
                  </p>
                </div>
                <div className="step-buttons">
                  <div className="box-button">
                    <p className="text-info">{t("online")}</p>

                    <Button
                      text={t("Buy online")}
                      as="link-out"
                      href="https://4f.com.pl/"
                    />
                  </div>
                  <div className="box-button">
                    <p className="text-info">{t("in-store")}</p>
                    <Button
                      text={t("Find a store")}
                      as="link-out"
                      href="https://4f.com.pl/shop/map"
                    />
                  </div>
                </div>
              </div>
              <div className="slider-box second">
                <p className="step-name">{t("step")} 2</p>
                <div className="step-image">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="78.868"
                    height="79.49"
                    viewBox="0 0 78.868 79.49"
                  >
                    <g transform="translate(0 0)">
                      <path
                        d="M-4904.313-1850.264l-3.3,7.078a2.1,2.1,0,0,1-2.791,1.016l-7.841-3.656a2.1,2.1,0,0,1-1.015-2.789,2.1,2.1,0,0,1,2.791-1.016l2.668,1.244a33.9,33.9,0,0,0-41.07-15.2,33.554,33.554,0,0,0-20.182,20.1,2.1,2.1,0,0,1-2.584,1.293,2.1,2.1,0,0,1-1.354-2.743,38.373,38.373,0,0,1,7.859-12.787,37.849,37.849,0,0,1,6.71-5.7,38.193,38.193,0,0,1,8.115-4.1,37.772,37.772,0,0,1,14.94-2.255,37.918,37.918,0,0,1,14.15,3.524,37.927,37.927,0,0,1,11.8,8.575,37.676,37.676,0,0,1,5.966,8.507l1.334-2.862a2.1,2.1,0,0,1,2.79-1.016,2.1,2.1,0,0,1,1.017,2.791"
                        transform="translate(4982.985 1869.834)"
                      />
                      <path
                        d="M-4908.271-1833.931a2.1,2.1,0,0,1,1.356,2.743,38.426,38.426,0,0,1-7.86,12.787,37.826,37.826,0,0,1-6.71,5.705,38.136,38.136,0,0,1-8.116,4.1,37.825,37.825,0,0,1-12.991,2.3c-.648,0-1.3-.018-1.947-.049a37.947,37.947,0,0,1-14.153-3.526,37.919,37.919,0,0,1-11.8-8.575,37.72,37.72,0,0,1-5.965-8.507l-1.334,2.862a2.1,2.1,0,0,1-2.791,1.016,2.1,2.1,0,0,1-1.015-2.791l3.3-7.078a2.1,2.1,0,0,1,2.792-1.016l7.84,3.656a2.1,2.1,0,0,1,1.015,2.789,2.1,2.1,0,0,1-2.791,1.016l-2.676-1.247a33.6,33.6,0,0,0,15.2,14.069,33.624,33.624,0,0,0,25.88,1.131,33.562,33.562,0,0,0,20.183-20.1,2.1,2.1,0,0,1,2.583-1.295"
                        transform="translate(4981.792 1885.779)"
                      />
                      <path
                        d="M-4922.539-1840.9l-8.717,8.043a.819.819,0,0,1-1.162-.052l-1.406-1.545-.173,17.874a.82.82,0,0,1-.82.812h-14.491a2.1,2.1,0,0,1-2.095-2.095v-.01a2.1,2.1,0,0,1,2.095-2.095h10.333a.818.818,0,0,0,.818-.812l.153-15.854a3.36,3.36,0,0,1,5.845-2.228.817.817,0,0,0,.606.268.817.817,0,0,0,.557-.217l2.395-2.209a.82.82,0,0,0,.025-1.182l-8.152-8.151a.815.815,0,0,0-.571-.24l-19.125-.216a.828.828,0,0,0-.591.242l-8.338,8.363a.821.821,0,0,0,.022,1.182l2.489,2.295a.82.82,0,0,0,1.139-.026,3.394,3.394,0,0,1,2.437-1.033,3.458,3.458,0,0,1,3.486,3.462l.025,12.009v6.454a2.1,2.1,0,0,1-2.095,2.095,2.1,2.1,0,0,1-2.1-2.095v-1.936l-.03-14.732-1.595,1.612a.823.823,0,0,1-1.14.026l-8.676-8.006a.82.82,0,0,1-.023-1.182l12.672-12.707a.819.819,0,0,1,.591-.242l22.608.255a.817.817,0,0,1,.57.24l12.455,12.453a.819.819,0,0,1-.025,1.182"
                        transform="translate(4986.325 1876.449)"
                      />
                    </g>
                  </svg>
                </div>
                <div className="step-title">
                  <p>{t("You’re bored with your clothes?")}</p>
                  <p>{t("Give them away so they can be reused.")}</p>
                </div>
                <div className="step-buttons">
                  <div className="box-button">
                    <p className="text-info">{t("online")}</p>
                    <Button
                      text={t("Donate them online")}
                      as="link"
                      href={t("order_courier_link")}
                    />
                  </div>
                  <div className="box-button">
                    <p className="text-info">{t("in-store")}</p>
                    <Button
                      text={t("Find a store")}
                      as="link"
                      href={t("join_link")}
                      state={{ option: "shop" }}
                    />
                  </div>
                </div>
              </div>
              <div className="slider-box third">
                <p className="step-name">{t("step")} 3</p>
                <div className="box-udo">
                  <a
                    href="https://www.ubraniadooddania.pl/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon"
                  >
                    <UdoIcon />
                  </a>
                  <div className="text">
                    <span className="bolder">{t("cleans")}</span>
                    <span className="bolder">{t("renews")}</span>
                    <span className="bolder">{t("repairs")}</span>
                  </div>
                </div>
                <div className="step-title">
                  <p>
                    {t(
                      "Your clothes will get a second life thanks to 4F's collaboration with UDO, which will prepare them for sale."
                    )}
                    {/* <a
                      href="https://www.ubraniadooddania.pl/"
                      target="_blank"
                      aria-label="Ubrania do oddania"
                      rel="noreferrer"
                    >
                      {t("4F's with UDO")}
                    </a>
                    {t(", which will prepare the clothings for sale.")} */}
                  </p>
                </div>
              </div>
              <div className="slider-box fourth">
                <p className="step-name">{t("step")} 4</p>
                <div className="step-image">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="90.753"
                    height="79.783"
                    viewBox="0 0 90.753 79.783"
                  >
                    <g transform="translate(0 0)">
                      <g transform="translate(0 0)">
                        <g transform="translate(0 52.557)">
                          <path
                            d="M90.753,8.969a5.915,5.915,0,0,0-8.245-5.438L79.317,4.9,74.775,6.848,70.659,8.612l-11.669,5a9.076,9.076,0,0,0-9.075-9.076H37.261a5.639,5.639,0,0,1-4.187-1.875c-.126-.141-.248-.273-.368-.392A7.749,7.749,0,0,0,27.23,0H2.267A2.267,2.267,0,0,0,0,2.268v0A2.267,2.267,0,0,0,2.267,4.537H25.386a7.816,7.816,0,0,1,5.458,2.317,7.638,7.638,0,0,0,.9.755,7.741,7.741,0,0,0,4.532,1.466H49.914a4.541,4.541,0,0,1,4.539,4.538H34.033a2.272,2.272,0,0,0-2.27,2.268,2.37,2.37,0,0,0,.031.377,2.272,2.272,0,0,0,2.238,1.893H55.054A19.184,19.184,0,0,0,62.607,16.6l3.009-1.288,12.243-5.247,4.312-1.848,1.779-.764a1.626,1.626,0,0,1,2.267,1.494v.568a2.255,2.255,0,0,1-1.371,2.074l-.38.163-4.2,1.8L60.575,22.008a8.4,8.4,0,0,1-3.312.682H2.344A2.317,2.317,0,0,0,.019,24.663a2.269,2.269,0,0,0,2.249,2.563H56.4a12.568,12.568,0,0,0,4.962-1.02l20.725-8.88,4.174-1.789.22-.094a7.041,7.041,0,0,0,4.269-6.473"
                            transform="translate(0)"
                          />
                        </g>
                        <path
                          d="M56.865,16.361,46.771,25.673a.948.948,0,0,1-1.345-.06L43.8,23.824l-.2,20.7a.952.952,0,0,1-.95.94H25.87a2.426,2.426,0,0,1-2.426-2.426v-.012A2.426,2.426,0,0,1,25.87,40.6H37.834a.948.948,0,0,0,.949-.94L38.96,21.3a3.891,3.891,0,0,1,6.768-2.58.951.951,0,0,0,1.347.059l2.773-2.558a.95.95,0,0,0,.028-1.369L40.437,5.413a.947.947,0,0,0-.661-.278L17.63,4.885a.959.959,0,0,0-.683.28L7.291,14.848a.951.951,0,0,0,.027,1.368L10.2,18.874a.948.948,0,0,0,1.317-.03,3.935,3.935,0,0,1,2.822-1.2,4.005,4.005,0,0,1,4.038,4.009l.028,13.9v7.473a2.426,2.426,0,1,1-4.851,0V40.792l-.035-17.057L11.672,25.6a.953.953,0,0,1-1.32.03L.305,16.362a.95.95,0,0,1-.027-1.369L14.952.28A.951.951,0,0,1,15.635,0L41.812.3a.948.948,0,0,1,.66.278l14.42,14.419a.949.949,0,0,1-.028,1.369"
                          transform="translate(16.791 0)"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="step-title">
                  <p>
                    {t(
                      "4F will re-introduce your clothes to the market for other people to enjoy them."
                    )}
                  </p>
                </div>
                <div className="step-buttons">
                  {/* <div className="box-button">
                    <p className="text-info">{t("online")}</p>
                    <p className="text-info sm">
                      {t(`Here you’ll buy clothes with 4F Change tag.`)}
                    </p>
                    <Button
                      text={t("Buy online")}
                      as="link-out"
                      href="https://4f.com.pl/kolekcje-specjalne/wear-fair.html"
                    />
                  </div> */}
                  <div className="box-button">
                    <p className="text-info">{t("in-store")}</p>
                    <p className="text-info sm">
                      {t("Here you’ll buy second-hand clothes.")}
                    </p>
                    <Button
                      text={t("Find a store")}
                      as="link"
                      href={t("join_link")}
                      state={{ option: "buy" }}
                    />
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </StyledCircle>
  )
}

export default Circle
